exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  background-color: rgb(21, 32, 71);\n  height: 10vh;\n  width: 100%;\n  margin-bottom: 0%;\n}\n.footer a {\n  font-size: 2em;\n  \n  color: white;\n  margin: 0 0;\n  font-weight: 500;\n\n\n}\n.footer.socialIcons {\n  margin-top: 0%;\n}\n.footerContainer {\n  background-color: rgb(21, 32, 71);\n  /* height: 10v; */\n  width: 100%;\n  margin-bottom: 0%;\n}\n.footerContainer h2 {\n  font-family: cursive;\n  margin-bottom: 0%;\n  font-size: 300%;\n color: white;\n font-style: italic;\n}\n", ""]);

// exports
